import React from 'react';
import { connect } from 'react-redux'

// Components
import { FixedSizeGrid as Grid } from 'react-window';
import SelectablePhoto from './SelectablePhoto.js';
import WindowedPhotoGrid from './WindowedPhotoGrid.js';
import Uploader from './Uploader.js';
import { Scrollbars } from 'react-custom-scrollbars';
import { addPhotoToPool, chooseAllPhotos, unchooseAllPhotos } from 'components/collage/CollageSlice.js'


// Images
import PlaceholderImg1 from 'img/placeholder-photos/beautiful-blurred-background-face-789304.jpg';
import PlaceholderImg2 from 'img/placeholder-photos/adult-blur-countryside-552563.jpg';
import PlaceholderImg3 from 'img/placeholder-photos/body-couple-daytime-821042.jpg';
import PlaceholderImg4 from 'img/placeholder-photos/casual-colorful-cute-667208.jpg';

// CSS
import './PhotoSelector.css';

// The item renderer is declared outside of the list-rendering component.
// So it has no way to directly access the data source.

class PhotoSelector extends React.Component {
  constructor(props) {
    super(props);

    // this.addPlaceholderImgs();
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (this.props.collage.photos.num != nextProps.collage.photos.num 
      || this.props.collage.photos.numChosen != nextProps.collage.photos.numChosen
    );
  }

  addPlaceholderImgs = () => {
    this.props.addPhotoToPool({
      src: PlaceholderImg1,
      width: 1667,
      height: 2468
    });
    this.props.addPhotoToPool({
      src: PlaceholderImg2,
      width: 4096,
      height: 2726
    });
    this.props.addPhotoToPool({
      src: PlaceholderImg3,
      width: 2048,
      height: 1366
    });
    this.props.addPhotoToPool({
      src: PlaceholderImg4,
      width: 2048,
      height: 1365
    });
  }

  handleSelectAllClick = () => {
    this.props.chooseAllPhotos();
  }

  handleRemoveAllClick = () => {
    this.props.unchooseAllPhotos();
  }

  render() {

    return (
      <div className="PhotoSelector">
        <button className="DividerDrag ButtonReset" aria-hidden="true"><span></span></button>
        <div className="PhotoSelectorGrid MainPadding">

          <Uploader />

          {(this.props.collage.photos.num > 0) &&
            <div className="PhotoSelectorActions">
              <div className="PhotoSelectBulkSelect">
                <button 
                  className="Button--TextLink ButtonReset" 
                  title="Add all photos to the collage"
                  onClick={this.handleSelectAllClick}
                >
                  Add All to Collage
                </button> | <button 
                  className="Button--TextLink ButtonReset" 
                  title="Remove all photos from the collage"
                  onClick={this.handleRemoveAllClick}
                >
                  Remove All
                </button>
              </div>
              <div>
                <p className="PhotoCount">{this.props.collage.photos.numChosen} / {this.props.collage.photos.num} selected</p>
              </div>
            </div>
          }

          <WindowedPhotoGrid />
        
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  collage: state.collage
});

export default connect(
  mapStateToProps,
  { addPhotoToPool, chooseAllPhotos, unchooseAllPhotos }
)(PhotoSelector)
